module.exports = __webpack_public_path__ + "static/media/dsc-04.1968c894.jpg";